import React from "react";
import {
  MenuItem,
  Typography,
  Divider,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import HoverMenu from 'material-ui-popup-state/HoverMenu'
import { usePopupState, bindHover, bindMenu } from "material-ui-popup-state/hooks";
import LogoutConfirmation from "./LogoutConfirmation";


const UserMenu = ({ pseudo }) => {
  const [openDialog, setOpenDialog] = React.useState(false);

  const popupState = usePopupState({
    variant: "popover",
    popupId: "user-menu",
  });
  const navigate = useNavigate();

  const handleProfile = () => {
    navigate("/me/events");
    popupState.close();
  };

  const handleMyPeriods = () => {
    navigate("/me/periods");
    popupState.close();
  };

  const handleMyTimelines = () => {
    navigate("/mes-frises");
    popupState.close();
  };

  return (
    <>
      <Button
        sx={{ textTransform: "none", fontWeight: "bold" }}
        {...bindHover(popupState)}
      >
        {pseudo || "Utilisateur"}
      </Button>
      <HoverMenu
        {...bindMenu(popupState)}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem
          onClick={() => {
            navigate("/me/profile");
            popupState.close();
          }}
        >
          <Typography variant="body1">Mon profil</Typography>
        </MenuItem>
        <MenuItem onClick={handleProfile}>
          <Typography variant="body1">{"Mes évènements"}</Typography>
        </MenuItem>
        <MenuItem onClick={handleMyPeriods}>
          <Typography variant="body1">{"Mes périodes"}</Typography>
        </MenuItem>
        <MenuItem onClick={handleMyTimelines}>
          <Typography variant="body1">{"Mes frises"}</Typography>
        </MenuItem>
        <Divider />
        <MenuItem onClick={() => setOpenDialog(true)}>
          Se déconnecter
        </MenuItem>
      </HoverMenu>
      <LogoutConfirmation open={openDialog} onClose={() => setOpenDialog(false)} />
    </>
  );
};

export default UserMenu;
